export enum ConditionType {
  ALL = "ALL",
  ANY = "ANY"
}

export enum ConditionOperator {
  EQUALS = "EQUALS",
  NOT_EQUALS = "NOT_EQUALS",
  IN = "IN",
  NOT_IN = "NOT_IN",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
  CONTAINS = "CONTAINS",
  NOT_CONTAINS = "NOT_CONTAINS"
}

export interface ConditionRule {
  field: string;
  operator: ConditionOperator;
  value?: string | number | boolean | string[] | null;
}

export interface ConditionRules {
  type: ConditionType;
  conditions: ConditionRule[];
}

export interface WorkflowStepWorkItem {
  id?: string;
  templateId: string;
  templateName?: string;
  templateDescription?: string;
  executionOrder: number;
  isConditional?: boolean;
  conditionRules?: ConditionRules;
  _delete?: boolean; // For marking items for deletion during updates
}

export interface WorkflowStepDepartment {
  id?: string;
  departmentId: string;
  departmentName?: string;
  executionOrder: number;
  isRequired?: boolean;
  workItems?: WorkflowStepWorkItem[];
  _delete?: boolean; // For marking departments for deletion during updates
}

export interface WorkflowStep {
  id?: string;
  name: string;
  description?: string;
  stepNumber: number;
  workflowStepDepartments: WorkflowStepDepartment[];
  _delete?: boolean; // For marking steps for deletion during updates
}

export interface Workflow {
  id?: string;
  name: string;
  description?: string;
  isActive?: boolean;
  createdAt?: string;
  workflowSteps: WorkflowStep[];
}

export interface WorkflowCreateRequest {
  name: string;
  description?: string;
  workflowSteps: WorkflowStep[];
}

export interface WorkflowCreateResponse {
  id: string;
  name: string;
  description?: string;
  message: string;
}

export interface WorkflowUpdateRequest {
  name?: string;
  description?: string;
  is_active?: boolean;
  workflow_steps?: WorkflowStep[];
}

export interface WorkflowUpdateResponse {
  id: string;
  name: string;
  description?: string;
  is_active: boolean;
  message: string;
}